import type React from 'react';

import { SearchIcon } from '@vlabs/icons';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button';
import { Button } from '@vlabs/uikit/components/controls/button';
import { routes } from '@vlapps/point/src/app/routes';
import qs from 'qs';
import { generatePath, useHistory } from 'react-router-dom';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { useSearchByExternalIdTranslation } from './i18n';
import type { SearchByExternalIdProps } from './types';

type SearchByExternalIdButtonProps = SearchByExternalIdProps & ButtonProps;

const displayName = 'SearchByExternalIdButton';
const testid = buildTestid(displayName);

function SearchByExternalIdButton({
  externalId,
  'data-testid': dataTestId = undefined,
  ...props
}: SearchByExternalIdButtonProps): React.JSX.Element {
  const { t } = useSearchByExternalIdTranslation();
  const history = useHistory();

  const handleClick = () => {
    history.push({
      pathname: generatePath(routes.search),
      search: qs.stringify({
        references: [{
          id: externalId,
          type: 'face',
          referenceType: 'face_external_id',
        }],
      }),
    });
  };

  return (
    <Button
      icon={<SearchIcon />}
      onClick={handleClick}
      variant="outlined"
      {...testid(dataTestId)}
      {...props}
    >
      {t('button')}
    </Button>
  );
}

SearchByExternalIdButton.displayName = displayName;

export { SearchByExternalIdButton };
